import { h, Fragment } from "preact";
import ProductOptionSwatchesGrouped from "./product-option-swatches-grouped";
import ProductOptionSwatches from "./product-option-swatches";
import ProductOptionDropdown from "./product-option-dropdown";
import ProductOptionPills from "./product-option-pills";

export default function ProductOption({
  option,
  updateOptionValue,
  selectedOptionValue,
  disabledOptionValues,
  allowMaterialGroups,
  optionStyle,
  selectedIsHidden,
}) {
  const isSwatch = option.optionValues.some(
    (optionValue) => optionValue.swatch,
  );

  const showMaterialGroups =
    allowMaterialGroups &&
    option.optionValues.some((optionValue) => optionValue.materialGroup);

  const optionValues = option.optionValues.filter((optionValue) => {
    if (selectedIsHidden) {
      return optionValue.name === selectedOptionValue;
    }

    return !optionValue.allMatchingVariantsHidden;
  });

  if (isSwatch) {
    if (showMaterialGroups) {
      return (
        <ProductOptionSwatchesGrouped
          optionValues={optionValues}
          optionName={option.optionName}
          updateOptionValue={updateOptionValue}
          selectedOptionValue={selectedOptionValue}
          disabledOptionValues={disabledOptionValues}
        />
      );
    } else {
      return (
        <ProductOptionSwatches
          optionValues={optionValues}
          optionName={option.optionName}
          updateOptionValue={updateOptionValue}
          selectedOptionValue={selectedOptionValue}
          disabledOptionValues={disabledOptionValues}
        />
      );
    }
  }

  if (optionStyle == "pill") {
    return (
      <ProductOptionPills
        optionValues={optionValues}
        optionName={option.optionName}
        updateOptionValue={updateOptionValue}
        selectedOptionValue={selectedOptionValue}
        disabledOptionValues={disabledOptionValues}
      />
    );
  }

  return (
    <ProductOptionDropdown
      optionValues={optionValues}
      optionName={option.optionName}
      updateOptionValue={updateOptionValue}
      selectedOptionValue={selectedOptionValue}
      disabledOptionValues={disabledOptionValues}
    />
  );
}
